import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {
  clearCommercialSession,
  getCommercialOrderStatus,
  hasPaidEntitlement,
  hasPaidReportAccess,
  readCommercialAccessToken,
  readCommercialOrderId,
} from "@/lib/commercialAccess";
import { useI18n } from "@/i18n";

export default function CommercialGate({ children, allowConsumed = false }) {
  const { t } = useI18n();
  const [state, setState] = useState({ checking: true, allowed: false, missing: false });

  useEffect(() => {
    let active = true;
    const orderId = readCommercialOrderId();
    const accessToken = readCommercialAccessToken();

    if (!orderId || !accessToken) {
      clearCommercialSession();
      setState({ checking: false, allowed: false, missing: true });
      return () => { active = false; };
    }

    getCommercialOrderStatus(orderId, accessToken)
      .then((status) => {
        if (!active) return;
        const allowed = allowConsumed
          ? hasPaidReportAccess(status)
          : hasPaidEntitlement(status);
        const consumed = status && status.status === "PAID" &&
          status.entitlement_status === "CONSUMED";
        setState({
          checking: false,
          allowed,
          missing: false,
          redirect: !allowed && consumed ? "/dashboard" : null,
        });
      })
      .catch((error) => {
        if (!active) return;
        if (error && error.status === 404) {
          clearCommercialSession();
          setState({ checking: false, allowed: false, missing: true });
          return;
        }
        setState({ checking: false, allowed: false, missing: false });
      });

    return () => { active = false; };
  }, [allowConsumed]);

  if (state.checking) {
    return (
      <div className="min-h-screen bg-navy-900 flex items-center justify-center text-slate-300">
        {t("commercial.checkingAccess")}
      </div>
    );
  }

  if (!state.allowed) {
    return (
      <Navigate
        to={state.redirect || "/checkout"}
        replace
        state={{ accessRequired: !state.missing }}
      />
    );
  }

  return children;
}
